<template>
  <md-input
      v-model.number="value"
      @keypress="onKeypress"
      @paste.prevent
      v-on="$listeners"
  />
</template>

<script>
/**
 *  TODO: Допилить
 *  Этот компонент пока не работает :(
 *  Проблема в фильтре (при unsetFilter() не меняется value input'a)
 *  проблема при создании нового правила: в value input'a не отображается 1 (значение item.timeout)
 *
 */
export default {
  name: 'TimeoutInputWings',
  props: {
    modelValue: String
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    onKeypress($event) {
      // Если введено боле пяти символов - нет ввода
      if (!/^.{0,4}$/.test($event.target.value)) {
        $event.preventDefault()
      }
      // Если вводится не число или ноль - нет ввода
      if (/[^\d]/g.test($event.key) || $event.key == '0') {
        $event.preventDefault();
      }
    }
  }
}
</script>
